import { Link } from 'react-router-dom';

const STEPS = [
  {
    number: '01',
    icon: 'ri-edit-box-line',
    title: 'Tell Us About Your Business',
    body: 'Enter your trade (roofing, landscaping, etc.), your target area, your offer, and the platform you want to run ads on. Takes about 60 seconds.',
    detail: 'No marketing knowledge required — just answer plain-English questions.',
  },
  {
    number: '02',
    icon: 'ri-cpu-line',
    title: 'AI Builds Your Full Ad Package',
    body: 'AdForge\'s AI writes your hooks, headlines, body copy, and CTAs — then generates up to 6 professional ad images, all sized for your chosen platform.',
    detail: 'Everything is ready in under 3 minutes.',
  },
  {
    number: '03',
    icon: 'ri-rocket-2-line',
    title: 'Copy, Download & Go Live',
    body: 'One-click copy your ad copy. Download your AI images. Paste them into Facebook Ads Manager, Google Ads, or wherever you\'re running your contractor advertising.',
    detail: 'No agency. No designer. No waiting.',
  },
];

export default function ContractorHowItWorks() {
  return (
    <section id="how-it-works" className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            How It Works
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            3 Steps to Your First AI Ad
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            From zero to a complete <strong>AI ads for contractors</strong> package in under 3 minutes.
            No experience needed.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14">
          {STEPS.map((step, i) => (
            <div key={step.number} className="relative flex flex-col items-center text-center gap-5">
              {i < STEPS.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[calc(50%+3rem)] right-0 h-px border-t-2 border-dashed border-orange-200" />
              )}
              <div className="relative w-20 h-20 flex items-center justify-center rounded-2xl bg-orange-50 border-2 border-orange-200 flex-shrink-0">
                <i className={`${step.icon} text-3xl text-orange-500`} />
                <span className="absolute -top-3 -right-3 w-7 h-7 flex items-center justify-center rounded-full bg-orange-500 text-white text-xs font-black">
                  {step.number.replace('0', '')}
                </span>
              </div>
              <div>
                <h3 className="text-lg font-bold text-stone-900 mb-2">{step.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed mb-3">{step.body}</p>
                <span className="inline-block text-xs font-semibold text-orange-600 bg-orange-50 border border-orange-100 rounded-full px-3 py-1">
                  {step.detail}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Generate Your First Ad Free
          </Link>
        </div>
      </div>
    </section>
  );
}
